import { Controller } from "@hotwired/stimulus"
import { callKarrotBridgeSafely } from "../../lib/karrot_bridge_utils"
import { readSessionJson, removeSessionItem } from "../../lib/session_storage"

// 재문의 차단 팝업의 "확인" 버튼.
// navbar 의 뒤로가기와 동일 전략: cs 플로우 내 진입이면 history.back, 직접 진입이면 webview close.
export default class extends Controller {
  back() {
    const stack = readSessionJson("csFlowStack", [])
    if (stack.length > 1) {
      window.history.back()
      return
    }

    callKarrotBridgeSafely(
      (bridge) => {
        removeSessionItem("csFlowStack")
        bridge.closeRouter({})
      },
      { fallback: () => window.history.back() }
    )
  }
}
